<section class="bg-grey-100 px-24 pb-12 pt-16 md:hidden">
    <h1 class="text-31 leading-36">{{ content().heroHeadline }}</h1>
    <h2 class="text-16 leading-27">{{ locationHeadline() }}</h2>
</section>
<section>
    <ui-m030-c020-teaser-allrounder
        [strongText]="content().heroBulletListHeadline ?? undefined"
        [list]="heroBullets() ?? undefined"
        [image]="content().heroImage?.url ?? ''"
        [imageAlt]="content().heroImage?.alt || (content().heroHeadline ?? '')"
        [isFirstView]="true"
    >
        <div [editable]="'businessCustomer.bullet'" [type]="'text'" bulletEdit></div>
        <h1 class="hidden md:block" headline>{{ content().heroHeadline }}</h1>
        <h2 class="mb-24 hidden md:block" subheadline>{{ locationHeadline() }}</h2>

        <div cta>
            @if (dealer().businessCenter) {
                <a ui-m010-c020-icon-link class="mb-[28px] hidden lg:flex" hyundaiRouterLink="." fragment="center">
                    Ihre Vorteile als Gewerbekunde
                </a>
            }
            <a
                class="button-primary lg:w-max"
                trackingElType="anchor link"
                tracking
                trackingEvent="engagement_click"
                trackingElLabel="Contact Request"
                trackingElTarget="contact"
                hyundaiRouterLink="."
                fragment="contact"
            >
                {{ content().heroBulletListCtaText }}
            </a>
        </div>
    </ui-m030-c020-teaser-allrounder>
</section>

@if (dealer().keyCampaign; as keyCampaign) {
    @if (
        keyCampaign.content &&
        keyCampaign.content.__typename === 'SalesCampaignContent' &&
        keyCampaign.content.isBusinessCampaign
    ) {
        <a ui-m040-c040-promotion-banner class="lg:order-2" [hyundaiRouterLink]="keyCampaign.detailUrl" isFirstView>
            {{ keyCampaign.teaserHeadline }}
            <br class="lg:hidden" />
            <span class="hidden lg:inline-block">-</span>
            {{ keyCampaign.teaserCopy }}
        </a>
    }
}

@if (content().contactEmployees.length > 0) {
    <section class="bg-grey-500">
        <div
            class="inner-page-wrapper flex flex-col pb-24 pt-32 lg:gap-56"
            [ngClass]="[
                content().contactEmployees.length > 1
                    ? '2xl:flex-row 2xl:items-center 2xl:justify-center 2xl:gap-56'
                    : 'lg:flex-row lg:items-center lg:justify-center lg:gap-56',
            ]"
        >
            <h3 class="mb-[28px] text-20 leading-25 lg:mb-0">
                {{ content().contactEmployees.length > 1 ? 'Unsere' : 'Unser' }} Ansprechpartner für Ihr Business:
            </h3>
            <div
                class="flex flex-col gap-32"
                [ngClass]="[content().contactEmployees.length > 2 ? 'flex-grow lg:grid lg:grid-cols-2' : 'lg:flex-row']"
            >
                @for (contact of content().contactEmployees; track $index; let index = $index) {
                    <ui-m040-c070-contact-person [data]="contact" isFirstView />
                }
            </div>
        </div>
    </section>
}

@if (content().campaigns && content().campaigns.length > 0) {
    <section class="inner-page-wrapper py-24 pt-40">
        <h3 class="mb-24 text-center font-headline text-24 font-medium leading-30 lg:mb-64 lg:text-34 lg:leading-41">
            Exklusive Angebote für Gewerbekunden
        </h3>
        <div class="grid grid-cols-2 place-content-center gap-x-16 gap-y-24 lg:grid-cols-4 lg:gap-56">
            @for (regularCampaign of content().campaigns; track regularCampaign) {
                <ui-m040-c050-card
                    [headline]="regularCampaign.teaserHeadline"
                    [text]="regularCampaign.teaserCopy ?? undefined"
                    [image]="regularCampaign.heroImage"
                    [link]="regularCampaign.detailUrl"
                    isFirstView
                />
            }
        </div>
    </section>
}

@defer {
    @if (dealer().businessCenter) {
        <section class="bg-grey-100" id="center">
            <div class="inner-page-wrapper flex flex-col pb-40 pt-24 lg:flex-row lg:flex-nowrap lg:gap-56 lg:pt-64">
                <div class="lg:w-4/12">
                    <h3 class="mb-12 text-16 leading-27 lg:text-22">
                        {{ content().businessCenterBulletListHeadline }}
                    </h3>
                    <ul class="flex flex-col gap-12">
                        @for (item of content().businessCenterBulletList; track $index) {
                            <li class="flex flex-row items-center gap-8 text-14 leading-20 lg:text-16 lg:leading-27">
                                @if (item.icon; as icon) {
                                    <ui-m000-c010-image
                                        class="shrink-0 self-start"
                                        [image]="{
                                            image: icon.url,
                                            desktop: { width: 100, height: 100 },
                                            tablet: { width: 100, height: 100 },
                                            mobile: { width: 100, height: 100 },
                                        }"
                                        [alt]="icon.alt || item.text"
                                        classList="size-[34px] lg:size-[40px] aspect-square"
                                        priority="false"
                                        cover
                                    />
                                } @else {
                                    <i class="icon-placeholder text-34 lg:text-[40px]"></i>
                                }
                                <span [innerHTML]="item.text"></span>
                            </li>
                        }
                    </ul>
                </div>

                @for (highlight of content().businessCustomerHighlights; track $index) {
                    <div class="pt-40 lg:w-4/12 lg:pt-0">
                        <ui-m000-c010-image
                            [classList]="'w-full'"
                            [alt]="highlight.image.alt || highlight.headline"
                            [image]="{
                                image: highlight.image.url,
                                desktop: { width: 500, height: 300 },
                                tablet: { width: 600, height: 240 },
                                mobile: { width: 600, height: 280 },
                            }"
                            priority="false"
                            cover
                        />

                        <h5 class="mb-12 mt-24 text-24 leading-30">
                            {{ highlight.headline }}
                        </h5>
                        <p>{{ highlight.copy }}</p>
                    </div>
                }
            </div>
        </section>
    }

    <section>
        <ui-m030-c130-warrenty-list [warrantyList]="content().warrantyList" [showMoreInfos]="true">
            <h2 headline>Umfangreiche Garantien</h2>
        </ui-m030-c130-warrenty-list>
    </section>

    <app-global-contact id="contact" isFirstView="false" />

    @if (content().legalLines; as legalLines) {
        <section class="inner-page-wrapper py-24 text-14 leading-20 text-grey-400">
            <p class="empty:*:h-24" [innerHTML]="legalLines.html"></p>
        </section>
    }
}
